import React from 'react';
import './Network.scss';
import {historyOfPush, showToast} from "../../asstes/js/IntegratedProcessing";

class Network extends React.Component {
	reloadUrl() {
		if (window.navigator.onLine) { // 在线
			historyOfPush('/index')
		} else { // 离线
			showToast('网络异常，请稍后重试！')
		}
	}

	render() {
		const netWorkImg = require('../../asstes/img/other/no-network.png');
		return (
			<div className="network-container">
				<img src={netWorkImg} alt="/"/>
				<p className="network-text">网络异常，请重试</p>
				<p className="return-btn flex-center-center" onClick={() => this.reloadUrl()}>刷新</p>
			</div>
		);
	}
}

export default Network
